import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {LinkLine} from '@dropbox/dig-icons/assets';

import {logWorkstreamsInteraction} from './workstreamsAnalytics';

/**
 * A narrative (or roadmap) doc, as a small link icon button (its label on hover). The same
 * size as the rail's chevrons, so rows keep their height. `insideLink` rows
 * (workstream rows are anchors) get a button that opens the doc, since a link
 * can't sit inside a link.
 */
export const NarrativeLinkIcon = ({
  link,
  insideLink = false,
  openedEvent = 'narrative_link_opened',
  logProps,
}: {
  link: {text: string; url: string};
  insideLink?: boolean;
  openedEvent?: 'narrative_link_opened' | 'roadmap_link_opened';
  // Says which row's link was opened (its workstream_id, or a group's pillar).
  logProps?: {[key: string]: string | number | undefined};
}) => (
  <Tooltip title={link.text} placement="top">
    {insideLink ? (
      <IconButton
        variant="borderless"
        size="small"
        aria-label={link.text}
        // Opening the doc shouldn't also follow or select the row it sits in.
        onClick={(event: React.MouseEvent) => {
          event.preventDefault();
          event.stopPropagation();
          logWorkstreamsInteraction(openedEvent, logProps);
          window.open(link.url, '_blank', 'noopener,noreferrer');
        }}
      >
        <UIIcon src={LinkLine} size="small" />
      </IconButton>
    ) : (
      <IconButton
        variant="borderless"
        size="small"
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={link.text}
        // Opening the doc shouldn't also select the row it sits in.
        onClick={(event: React.MouseEvent) => {
          event.stopPropagation();
          logWorkstreamsInteraction(openedEvent, logProps);
        }}
      >
        <UIIcon src={LinkLine} size="small" />
      </IconButton>
    )}
  </Tooltip>
);
